import React, { useRef, useState, useEffect } from 'react';

// Largura real de uma folha A4 a 96dpi — a mesma usada pelo canvas do editor e pelo PDF.
const PAGE_WIDTH = 794;

// Renderiza o documento na largura real da folha e o escalona proporcionalmente para
// caber no espaço disponível. Assim a prévia é fiel ao PDF: nada reflui, quebra ou corta.
export default function DocumentPreview({ children }) {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [box, setBox] = useState({ scale: 1, height: 0, offsetX: 0 });

  useEffect(() => {
    const container = containerRef.current;
    const content = contentRef.current;
    if (!container || !content) return;

    let frame = null;
    const update = () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        const available = container.clientWidth;
        // Painel fechado (largura 0): mantém a última escala para a animação de saída.
        if (!available) return;
        const scale = Math.min(1, available / PAGE_WIDTH);
        setBox({
          scale,
          height: content.offsetHeight * scale,
          offsetX: Math.max(0, (available - PAGE_WIDTH * scale) / 2),
        });
      });
    };

    update();
    const observer = new ResizeObserver(update);
    observer.observe(container);
    observer.observe(content);
    return () => {
      observer.disconnect();
      if (frame) cancelAnimationFrame(frame);
    };
  }, []);

  return (
    <div ref={containerRef} className="w-full">
      <div className="relative" style={{ height: box.height }}>
        <div
          ref={contentRef}
          className="absolute top-0"
          style={{
            width: PAGE_WIDTH,
            left: box.offsetX,
            transform: `scale(${box.scale})`,
            transformOrigin: 'top left',
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
